import MasterTable from "../../views/dashboard/widget/MasterTabel";
import { useGlobalState } from "../../services/hostelConst.js";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  getSubjectList,
  updateSubjectStatus,
  deleteSubject,
} from "../../services/Academic-Services";

import AddSubjectForm from "../FormComponents/AddSubject";
const SubjectTable = () => {
  const {
    _advanceFilterList,
    updateAdvanceFilterList,
    resetAdvanceFilterData,
  } = useGlobalState();
  useEffect(() => {
    resetAdvanceFilterData();
    updateAdvanceFilterList((prev) => {
      return {
        ...prev,
        date: true,
        status: true,
        region: true,
        site: true,
        department: true,
      };
    });

    return () => {};
  }, []);

  return (
    <>
      <MasterTable
        getTableData={getSubjectList}
        deleteRow={deleteSubject}
        updateStatus={updateSubjectStatus}
        tab1={"Academic"}
        tab2={"Subject"}
        AddForm={AddSubjectForm}
        actions={{
          status: true,
          edit: true,
          delete: true,
        }}
      />
    </>
  );
};

export default SubjectTable;
